var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { EntityTypes } from "../../../../../models/basics/basics.models";
import { EventLogsClientService } from "../../../../../services/event-log/event-log-client.service";
var ChangeLogsStatusDialog = /** @class */ (function () {
    function ChangeLogsStatusDialog(logsService, dialogClientService, notificationService) {
        this.logsService = logsService;
        this.dialogClientService = dialogClientService;
        this.notificationService = notificationService;
        this.eventLogType = EntityTypes.EventLog;
    }
    ChangeLogsStatusDialog.prototype.activate = function (model) {
        this.ids = model.ids;
        this.reload = model.reload;
        this.statusId = model.statusId;
        this.statusReasonId = model.statusReasonId;
    };
    ChangeLogsStatusDialog.prototype.cancel = function () {
        this.dialogClientService.hide();
    };
    ChangeLogsStatusDialog.prototype.changeStatus = function () {
        var _this = this;
        this.logsService.changeStatus(this.ids, this.nextStatusReasonId).then(function (response) {
            _this.notificationService.show("Success", "Status changed successfully", NotificationType.Success);
            _this.dialogClientService.hide();
            if (_this.reload) {
                _this.reload();
            }
        }).catch(function (ex) {
            _this.notificationService.show("Error", "Failed to change Status", NotificationType.Error);
        });
    };
    ChangeLogsStatusDialog = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [EventLogsClientService,
            DialogClientService,
            NotificationClientService])
    ], ChangeLogsStatusDialog);
    return ChangeLogsStatusDialog;
}());
export { ChangeLogsStatusDialog };
